import React from "react"
// import "./ArticleShare.scss"

// Images
import FacebookQA from "./images/facebook-qa.svg"
import TwitterQA from "./images/twitter-qa.svg"
import LinkedInQA from "./images/linkedin-qa.svg"
import FacebookDigital from "./images/facebook-digital.svg"
import TwitterDigital from "./images/twitter-digital.svg"
import LinkedInDigital from "./images/linkedin-digital.svg"
import Facebook from "./images/facebook.svg"
import Twitter from "./images/twitter.svg"
import LinkedIn from "./images/linkedin.svg"

class ArticleShare extends React.Component {

  componentDidMount() {
    this.url = window.location.href
    this.fbShareURL = "https://www.facebook.com/sharer/sharer.php?u=" + this.url
    this.twShareURL = "https://twitter.com/home?status=" + this.url
    this.liShareURL = "https://www.linkedin.com/shareArticle?mini=true&url=" + this.url + "&title=Nesta&summary=&source="
  }

  render() {
    const {modifier} = this.props,
          {style} = this.props,
          {col} = this.props,
          classes = (modifier ? `article__share-col article__share-col--${modifier}` : "article__share-col")

    let fbIcon,
        fbWidth,
        fbHeight,
        twIcon,
        twWidth,
        twHeight,
        liIcon,
        liWidth,
        liHeight

    switch (style) {
      case ('qa'):
        fbIcon = FacebookQA
        fbWidth = 9
        fbHeight = 18
        twIcon = TwitterQA
        twWidth = 19
        twHeight = 15
        liIcon = LinkedInQA
        liWidth = 19
        liHeight = 18
        break;
      case ('digital'):
        fbIcon = FacebookDigital
        fbWidth = 20
        fbHeight = 30
        twIcon = TwitterDigital
        twWidth = 30
        twHeight = 27
        liIcon = LinkedInDigital
        liWidth = 30
        liHeight = 29
        break;
      default:
        fbIcon = Facebook
        fbWidth = 9
        fbHeight = 18
        twIcon = Twitter
        twWidth = 19
        twHeight = 15
        liIcon = LinkedIn
        liWidth = 19
        liHeight = 18
    }

    return (
      <div className={`${classes} col ${col}`}>
        <div className="article__share">
          <ul>
            <li><a href={this.fbShareURL} target="_blank" rel="noopener noreferrer">
              <img
                src={fbIcon}
                width={fbWidth}
                height={fbHeight}
                alt="Share on Facebook"
              />
            </a></li>
            <li><a href={this.twShareURL} target="_blank" rel="noopener noreferrer">
              <img
                src={twIcon}
                width={twWidth}
                height={twHeight}
                alt="Share on Twitter"
              />
            </a></li>
            <li><a href={this.liShareURL} target="_blank" rel="noopener noreferrer">
              <img
                src={liIcon}
                width={liWidth}
                height={liHeight}
                alt="Share on LinkedIn"
              />
            </a></li>
          </ul>
        </div>
      </div>
    )
  }
}

export default ArticleShare